import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ChevronDown2 = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20, strokeWidth = 1.5 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M6.5 8.687L10.0006 11.893L13.5 8.687"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default ChevronDown2
